import React from 'react';
import './ResetPassword.scss'
import Copyright from './Copyright';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { PASSWORD_RESET } from '../../api/urls';

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [emailTouched, setEmailTouched] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [linkSent, setLinkSent] = React.useState(false);

  const isValidEmail = (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setEmailTouched(true);
    setError(null);

    if (!isValidEmail(email)) {
      setError('Podaj poprawny adres email');
      return;
    }

    setLoading(true);
    try {
      await fetch(PASSWORD_RESET, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setLinkSent(true);
    } catch (err: any) {
      setError('Wystąpił błąd podczas wysyłania linku resetującego');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-page pp-font-geist">
      <div className="reset-password-page__wrapper">
        <div className="d-flex justify-content-center reset-password-page__logo">
          <img
            alt="mooveno-logo"
            src={`/login/mooveno-logo-dark.svg`}
            style={{ width: 182, height: 'auto', maxWidth: '90%', cursor: 'pointer' }}
            onClick={() => navigate('/login')}
          />
        </div>
        <Card className="reset-password-page__card">
          {!linkSent ? (
            <>
              <div className="reset-password-page__header">
                <h1 className="reset-password-page__title">Resetowanie hasła</h1>
                <p className="reset-password-page__subtitle">Podaj adres email powiązany z Twoim kontem, a prześlemy tam link do zmiany hasła.</p>
              </div>
              <form onSubmit={onSubmit} className="reset-password-page__form">
                <div className="reset-password-page__field">
                  <label htmlFor="email">Adres email*</label>
                  <InputText
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onBlur={() => setEmailTouched(true)}
                    placeholder="Wprowadź email"
                    className={`w-100${emailTouched && !isValidEmail(email) ? ' p-invalid' : ''}`}
                    autoComplete="email"
                    type="email"
                  />
                </div>
                <Button
                  className="reset-password-page__submit"
                  type='submit'
                  label={loading ? 'Wysyłanie…' : 'Wyślij link resetujący'}
                  loading={loading}
                  disabled={!email || !isValidEmail(email) || loading}
                />
                {(error || (emailTouched && !isValidEmail(email))) && (
                  <div className='text-danger' role='alert'>
                    {error || 'Podaj poprawny adres email'}
                  </div>
                )}
              </form>
              <p className="reset-password-page__hint">
                Link resetujący będzie ważny przez 15 minut<br />
                Nie otrzymałeś emaila? Sprawdź folder spam
              </p>
            </>
          ) : (
            <div className="d-flex flex-column align-items-center pb-2">
              <img
              alt='mooveno-logo'
              className="logo"
              src={`/login/password-reset-mail.svg`}
              style={{ width: 100, height: 'auto', maxWidth: '90%', cursor: 'pointer' }}
              onClick={() => navigate('/')}
              />
              <h2>Link został wysłany!</h2>
              <span className="text-center mb-4" style={{ fontWeight: 400, color: '#4C6483' }}>
                Link do zmiany Twojego hasła został Ci przesłany na adres: {email}
              </span>
              <div className='d-flex justify-content-center text-justify px-5' style={{ fontSize: '14px' }}>
                <p>Link resetujący będzie ważny przez 15 minut<br></br>
                  Nie otrzymałeś emaila? Sprawdź folder spam</p>
              </div>
              <Button
                className="reset-password-page__secondary-button"
                label={"Powrót do logowania"}
                icon="pi pi-arrow-left"
                iconPos="left"
                onClick={() => navigate('/login/')}
              />
            </div>
          )}
        </Card>
        <Copyright className="reset-password-page__copyright" />
      </div>
    </div>
  );
};

export default ResetPassword;